export { AlarmDefinitionsSingleEditComponent, COMPONENT_NAME} from './alarm-definitions-single-edit.component'
export { AlarmDefinitionsSingleEditController } from './alarm-definitions-single-edit.controller'